import * as React from "react";

interface EventInfoSectionsProps {
  pictureLink?: string;
  name: string;
  description: string;
  usefulInformation?: string;
}

const EventInfoSections: React.FC<EventInfoSectionsProps> = ({ pictureLink, name, description, usefulInformation }) => (
  <div className="d-flex flex-column gap-4 col-8">
    {pictureLink && (
      <img
        src={pictureLink}
        alt={name || "Event"}
        style={{ height: "auto", maxHeight: 474, objectFit: "contain" }}
        className="w-100 mb-2"
      />
    )}
    <div className="d-flex flex-column p-4 border">
      <h2 className="mb-3">Overview</h2>
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </div>
    {usefulInformation && (
      <div className="d-flex flex-column p-4 border">
        <h2 className="mb-3">Useful information</h2>
        <div dangerouslySetInnerHTML={{ __html: usefulInformation }} />
      </div>
    )}
  </div>
);

export default EventInfoSections;
